<template>
    <v-container id="grn-items" class="custom-container">
       
      <v-data-table
        :headers="headers"
        :items="grnItems"
        :hide-default-footer="true"
        :disable-sort="true"
        :hide-default-header="true"
      >
        <template v-slot:header="{ props }">
          <thead>
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                class="custom-header"
                style="border-bottom: thin solid rgb(0 0 0 / 0%);"
              >
                <p>{{ header.text }}</p>
              </th>
            </tr>
          </thead>
        </template>
  
        <template v-slot:item="{ item, index }">
          <tr :key="index">
            <td>
              <v-autocomplete
                v-model="item.product_code"
                required
                dense
                outlined
                clearable
                :items="products"
                item-text="product_code"
                item-value="product_code"
                @change="onProductSelect(item)"
                
              ></v-autocomplete>
            </td>
            <td>
      <v-autocomplete
        v-model="item.batch_id"
        required
        dense
        outlined
        clearable
        :items="batches"
        item-text="batch_code"
        item-value="id"
        @change="onBatchSelect(item)"
      ></v-autocomplete>
    </td>
            <td class="wider-description">
              <v-text-field
                v-model="item.description"
                placeholder="Description"
                outlined
                dense
                clearable
                @change="onProductSelect(item)"
              ></v-text-field>
            </td>
            
            
            <td>
              <v-text-field
                v-model="item.quantity_received"
                type="number"
                dense
                min="0"
                :max="quantityOrdered"
                outlined
                clearable
                @change="onProductSelect(item)"
               @input="checkQuantityReceived(item)"
               
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                v-model="item.unit_price"
                type="number"
                dense
                min="0"
                outlined
                clearable
                @input="updateValues(item)"
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                v-model="item.tax_percent"
                dense
                outlined
                @input="updateValues(item)"
                
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                v-model="item.discount_percent"
                type="number"
                dense
               
                outlined
                clearable
                @input="updateValues(item)"
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                v-model="item.total_price"
                dense
                outlined
                disabled
              ></v-text-field>
            </td>
            <td class="pb-5">
              <v-icon size="30" @click="deleteItem(index)" color="red">
                mdi-delete
              </v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
      
      
  
      <v-row class="mt-0">
        <v-col v-if="!addingNewRow" class="text-left">
          <v-icon size="40" color="blue" @click="addNewRow">mdi-plus</v-icon>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  export default {
    props: {
      InitialGrnItems: Array,
      products: { type: Array, required: true },
      batches:{ type: Array, required: true }
    },
   
    data() {
      return {
        headers: [
          { text: 'Item Code', value: 'product_code' },
          { text: 'Batch', value: 'batch_id' }, 
          { text: 'Description', value: 'description' },
         
          { text: 'Quantity Received', value: 'quantity_received' },
          { text: 'Price', value: 'unit_price' },
          { text: 'TAX (%)', value: 'tax_percent' },
          { text: 'Discount (%)', value: 'discount_percent' },
          { text: 'Total (Rs.)', value: 'total_price' },
          { text: '', value: 'actions', sortable: false },
        ],
        grnItems: [],
        addingNewRow: false,
        totalAmount: 0,
        ordered: 0,
      };
    },
    
    watch: {
      InitialGrnItems: {
        immediate: true,

        handler(newVal) {
            
          if (newVal && newVal.length > 0) {
            this.grnItems = [...newVal];
            
          } else {
            this.grnItems.push(this.getDefaultRow());
             console.log("new val : ",newVal);
          }
        },
      },
      grnItems: {
        deep: true,

        handler(newValue) {
          const total = this.calculateTotalAmount();
          this.$emit('total', total);
          this.$emit('items', newValue);
        },
      },
    },
    methods: {
        
      onProductSelect(item) {
        const selectedProduct = this.products.find(
          (product) => product.product_code === item.product_code
        );
    
        if (selectedProduct) {
            
            
            item.unit_price = selectedProduct.unit_price;
            item.quantity_received = selectedProduct.quantity_received;
            item.description = selectedProduct.description;
            item.discount_percent = selectedProduct.discount_percent || 0;
            item.tax_percent = selectedProduct.tax_percent || 0;
            this.updateValues(item);

        }
      },
      onBatchSelect(item) {
    const selectedBatch = this.batches.find(
      (batch) => batch.id === item.batch_id
    );
    if (selectedBatch) {
      // Example: Add any batch-specific logic here
      item.description = selectedBatch.description || item.description;
      item.expiry_date = selectedBatch.expiry_date; // If applicable
      this.updateValues(item);
    }
  },
     
      updateValues(item) {
        const baseAmount = item.quantity_received * item.unit_price;
        const discountAmount = (baseAmount * item.discount_percent) / 100;
        const finalAmount = baseAmount - discountAmount;
  
        item.total_price = (finalAmount * (1 + 10 / 100)).toFixed(2);
        item.tax_amount = (finalAmount * (10 / 100)).toFixed(2);
        item.discount_amount= (discountAmount).toFixed(2);
        
        
      },
      deleteItem(index) {
        this.grnItems.splice(index, 1);
      },
      addNewRow() {
        this.addingNewRow = true;
        this.$nextTick(() => {
          this.grnItems.push(this.getDefaultRow());
          this.addingNewRow = false;
        });
      },
      getDefaultRow() {
        return { description: '', batch_id: '', quantity_received: 0,unit_price: 0,discount_amount:0, discount_percent: 0, total_price: 0, tax_percent: 0 };
      },
      calculateTotalAmount() {
        this.totalAmount = 0;
        this.grnItems.forEach((item) => {
          this.totalAmount += parseFloat(item.total_price);
          
        });
        return this.totalAmount;
      },
    },
    
  };
  </script>
  
  <style scoped>
  .v-text-field--outlined >>> fieldset {
    border-color: rgba(192, 0, 250, 0.215);
    border-radius: 10px;
    
  }
  .custom-container {
  width: 100%; /* Make container stretch to full width */
  max-width: 100%; /* Ensure container uses the full available space */
  padding: 0 !important; /* Remove padding or set a custom value */
  margin: 0 !important; /* Remove margins or set a custom value */
  
  }
  .v-data-table td {
    padding: 1px !important; /* Adjust padding to reduce extra space */
    margin: 0 !important;
    text-align: center; /* Optional: Align text in the middle */
    width: 10%; /* Make each <td> take equal space (100% / 8 columns = 12.5%) */
  }
  .v-data-table th {
    padding: 1px !important;
    text-align: center; /* Optional: Align text in the middle */
  }

  .v-data-table {
    table-layout: fixed; /* Forces table to distribute space evenly across columns */
  }
  </style>